var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.742,
    height: 82.326,
    viewBox: "0 0 90.742 82.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265",
    transform: "translate(-1019.983 -455.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(1019.983 455.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M83.18,41.5H48.607a4.486,4.486,0,0,1-3.781-2.11l-2.447-3.866A7.465,7.465,0,0,0,36.085,32H7.562A7.754,7.754,0,0,0,0,39.916V106.41a7.754,7.754,0,0,0,7.562,7.916H83.18a7.754,7.754,0,0,0,7.562-7.916V49.415A7.754,7.754,0,0,0,83.18,41.5Zm4.537,64.911a4.647,4.647,0,0,1-4.537,4.75H7.562a4.647,4.647,0,0,1-4.537-4.75v-47.5a4.647,4.647,0,0,1,4.537-4.75H83.18a4.647,4.647,0,0,1,4.537,4.75Zm0-53.828c-.057-.044-.126-.078-.185-.122-.126-.093-.257-.174-.389-.26a7.351,7.351,0,0,0-.789-.448c-.151-.073-.295-.141-.454-.2a7.35,7.35,0,0,0-.9-.294c-.142-.036-.28-.082-.425-.111A7.182,7.182,0,0,0,83.18,51H7.562a7.184,7.184,0,0,0-1.4.149c-.151.028-.283.074-.425.111a7.349,7.349,0,0,0-.9.294c-.151.062-.3.13-.454.2a7.35,7.35,0,0,0-.789.448c-.132.085-.263.166-.389.26-.059.044-.127.078-.185.122l.006-12.669a4.647,4.647,0,0,1,4.537-4.75H36.085a4.486,4.486,0,0,1,3.781,2.11l2.452,3.865a7.461,7.461,0,0,0,6.29,3.524H83.18a4.647,4.647,0,0,1,4.537,4.75Z",
    transform: "translate(0 -32)",
    fill: "#5a6168"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(1049.041 483.836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    transform: "translate(5.443 5.443)",
    fill: "#fff",
    stroke: "#ced4d9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.028,
    height: 39.006,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28.028,
    height: 38.006,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    transform: "translate(2.721 1.814)",
    fill: "#fff",
    stroke: "#ced4d9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.028,
    height: 39.913,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28.028,
    height: 38.913,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#ced4d9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.028,
    height: 39.006,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28.028,
    height: 38.006,
    rx: 1.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive2Icon);
export default __webpack_public_path__ + "static/media/archive2_icon.b32d1cf23821301406415b34f5eaf01b.svg";
export { ForwardRef as ReactComponent };